/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import { useSelector } from 'react-redux';
import { StateRedux } from '../../../store/type-redux';
import {
  Modal, InputUnform, TextareaUnform, SelectUnform,
} from '../../../components';
import { api, alerts, doRefreshToken } from '../../../utils';
import { Permissao, Aplicacao } from '../../../@types/exports';
import validarErroForm from './validar-erro-form';

interface Props {
  atualizarLista: () => void;
  itemParaEditar?: Permissao;
  aplicacoes: Aplicacao[];
}
const Texto = (textoToReplace: any) => {
  const { t } = useTranslation();
  return (
    t(`permissoes.${textoToReplace}`)
  );
};
const HtmlToast = (texto: any) => {
  const { textoToReplace } = texto;
  return (
    <div>
      {Texto(textoToReplace)}
    </div>
  );
};

const FormCadastroPermissao = ({ atualizarLista, itemParaEditar, aplicacoes }: Props) => {
  // Verifica se é necessário realizar o refresh token
  doRefreshToken.getRefreshToken();
  const formRef = useRef<FormHandles>(null);
  const [permissao, setPermissao] = useState<Permissao | undefined>(itemParaEditar);
  const [loadButton, setLoadButton] = useState<boolean>(false);
  const closeModal = () => {
    const modal = document.getElementById('modal-close-modal-cadastro-permissao');
    modal?.click();
  };
  // Filtra aplicações ativas do Realm
  const aplicacoesFilter = aplicacoes
    .filter((element) => (element.ativo === true));
  const options = aplicacoesFilter.map((a) => ({ value: String(a.id), label: a.nome }));

  const handleSubmit = async (data: Permissao) => {
    try {
      formRef.current?.setErrors({});

      await validarErroForm(data);

      setLoadButton(true);
      try {
        await api.createPermissao(data);
        toast.success(
          <div>
            {data.name}
            &nbsp;
            <HtmlToast textoToReplace="cadastradoSucesso" />
          </div>,
        );
      } catch (err) {
        console.log('Erro ao criar perfil', err);
      }

      atualizarLista();
      closeModal();
    } catch (error) {
      alerts.exibirErrorCatch(error, formRef);
    } finally {
      setTimeout(() => setLoadButton(false), 1000);
    }
  };

  const handleEditar = async (data: Permissao) => {
    try {
      formRef.current?.setErrors({});

      await validarErroForm(data);
      let dataUpdate: any = {};
      dataUpdate = data;
      dataUpdate.aplicacoesIdNew = dataUpdate.aplicacoesId;

      const aplicacoesId = permissao?.aplicacoes.map((element: any) => (element.id));
      const namePermissao = permissao?.name;
      dataUpdate = { ...data, aplicacoesId };
      setLoadButton(true);

      closeModal();
      try {
        await api.updatePermissao(namePermissao, dataUpdate);
        toast.success(
          <div>
            <HtmlToast textoToReplace="form.alteradoComSucesso" />
          </div>,
        );
        // alerts.exibirToastSuccess('Pefil alterado com sucesso!');
      } catch (err) {
        closeModal();
        alerts.exibirErrorCatch(err, formRef);
      }
      atualizarLista();
    } catch (error) {
      alerts.exibirErrorCatch(error, formRef);
    } finally {
      setTimeout(() => setLoadButton(false), 1000);
    }
  };

  useEffect(() => {
    setPermissao(itemParaEditar);
  }, [itemParaEditar]);

  return (
    <Form ref={formRef} onSubmit={itemParaEditar ? handleEditar : handleSubmit}>
      <Modal
        id="modal-cadastro-permissao"
        title={itemParaEditar ? Texto('form.editar') : Texto('form.cadastro')}
        confirmButtonText={itemParaEditar ? Texto('botoes.editar') : Texto('botoes.cadastrar')}
        cancelButtonText={Texto('botoes.voltar')}
        loadButton={loadButton}
        size="lg"
      >
        <div className="m-portlet__body">
          <div className="form-group m-form__group row">
            <span className="col-3 col-form-span">
              {Texto('form.nomePerfil')}
              <span className="text-danger">*</span>
            </span>
            <div className="col-8">
              <InputUnform
                key={permissao?.id}
                name="name"
                className="form-control m-input"
                type="text"
                defaultValue={permissao?.name}
              />
            </div>
          </div>
          <div className="form-group m-form__group row">
            <span className="col-3 col-form-span">
              {Texto('form.descricao')}
              <span className="text-danger">*</span>
            </span>
            <div className="col-8">
              <TextareaUnform
                key={permissao?.id}
                name="description"
                className="form-control m-input"
                defaultValue={permissao?.description}
              />
            </div>
          </div>
          <div className="form-group m-form__group row">
            <span className="col-3 col-form-span">
              {Texto('aplicacoes')}
            </span>
            <div className="col-8">
              <SelectUnform
                key={permissao?.id}
                placeholder={Texto('form.selecioneAplicacoes')}
                name="aplicacoesId"
                isMulti
                optionDefault={(
                  itemParaEditar?.aplicacoes
                    .map((a: any) => a.id)
                    .map((value: number) => options.find((o) => Number(o.value) === value))
                )}
                options={options}
              />
            </div>
          </div>
        </div>
      </Modal>
    </Form>
  );
};

FormCadastroPermissao.defaultProps = {
  itemParaEditar: undefined,
};

export default FormCadastroPermissao;
